import { HeroSection } from "@/components/landing/hero-section";
import { TrustedPartners } from "@/components/landing/TrustedPartners";
import { EventMarketplace } from "@/components/landing/EventMarketplace";
import { FeaturesSection } from "@/components/landing/features-section";
import { DemoSection } from "@/components/landing/demo-section";
import { TestimonialsSection } from "@/components/landing/testimonials-section";
import { PricingSection } from "@/components/landing/pricing-section";
import { CTASection } from "@/components/landing/cta-section";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Compact spacing between sections */}
      <div className="space-y-0">
        <HeroSection />
        <TrustedPartners />
        <EventMarketplace />
        {/* <FeaturesSection />
        <DemoSection /> 
        <PricingSection /> */}
        <TestimonialsSection />
        <EventMarketplace />
        {/* <CTASection /> */}
      </div>
    </div>
  );
};

export default Index;
